import axios from 'axios';
import { baseUrl } from '../hooks/useEndpoints';
import {
  ICreateTrainingBlockBody,
  IReorderTrainingBlocksBody,
  ITrainingBlock,
  ITrainingMixResponse,
  IUpdateTrainingBlockBody,
  TrainingMixPeriodType,
} from '../models/allenamenti';

export const allenamentiEndpoints = {
  /** Blocchi di una squadra fra due giorni compresi. */
  list: (teamId: string, from: string, to: string) =>
    axios.get<ITrainingBlock[]>(`${baseUrl}/training-blocks`, {
      params: { teamId, from, to },
    }),

  create: (body: ICreateTrainingBlockBody) =>
    axios.post<ITrainingBlock>(`${baseUrl}/training-blocks`, body),

  update: (id: string, body: IUpdateTrainingBlockBody) =>
    axios.patch<ITrainingBlock>(`${baseUrl}/training-blocks/${id}`, body),

  /**
   * Riordino verticale e spostamento di giorno, in una scrittura sola.
   * Ritorna i blocchi toccati, già riordinati.
   */
  reorder: (body: IReorderTrainingBlocksBody) =>
    axios.put<ITrainingBlock[]>(`${baseUrl}/training-blocks/order`, body),

  remove: (id: string) => axios.delete<void>(`${baseUrl}/training-blocks/${id}`),

  /**
   * Vista Analisi: composizione del lavoro pianificato su un periodo.
   * `compare=1` chiede anche il confronto col periodo immediatamente precedente.
   */
  analysis: (teamId: string, period: TrainingMixPeriodType, ref: string) =>
    axios.get<ITrainingMixResponse>(`${baseUrl}/training-blocks/analysis`, {
      params: { teamId, period, ref, compare: 1 },
    }),
};
